import { connect } from 'react-redux';
import { Dispatch } from '../../../common/state';
import { closeOfficeCalculator } from '../../state/office_calculator';

import { OfficeCalculator } from './index';

export const OfficeCalculatorContainer = connect(null, (dispatch: Dispatch) => ({
  onClose: () => {
    dispatch(closeOfficeCalculator());
  },
}))(OfficeCalculator);
